import React, { useEffect, useState, useRef, useImperativeHandle } from 'react';
import { showToast } from '../../../stores/ToastStore';
import { useGetDocuments, useGetSignedUrls, } from '../../../utils/DocumentsHooks';
import { DOCUMENT_STATUSES } from '../documents/Document';
import LetterAvatar from './LetterAvatar';
export const Avatar = React.forwardRef(({ userId, altName, className = null, style = null, overlapping = false, useLetters = false, user, }, ref) => {
    const [signedUrl, setSignedUrl] = useState('https://assets.cargomatic.com/default.jpg');
    const [showLetters, setShowLetters] = useState(false);
    const [pendingOverlay, setPendingOverlay] = useState(false);
    const [oldDocument, setOldDocument] = useState(null);
    const { data: documentData, error: documentError, refetch: documentsRefetch, } = useGetDocuments({
        foreignKeys: [userId || ''],
        type: 'profile_picture',
        options: {
            order: {
                field: 'createdAt',
                direction: 'desc',
            },
            limit: 1,
        },
    });
    const { data: signedUrlsData, error: signedUrlsError, refetch: signedUrlsRefetch, } = useGetSignedUrls({
        foreignKeys: [userId || ''], // use single when endpoint could search by foreightKey
    });
    const refetchTimeoutRef = useRef(0);
    useEffect(() => {
        var _a, _b;
        if (documentError) {
            showToast('Get Avatar Error', `Get Avatar failed with error: ${documentError}`, 'error');
        }
        if (signedUrlsError) {
            showToast('Get Avatar SignedUrl Error', `Get Avatar SignedUrl failed with error: ${signedUrlsError}`, 'error');
        }
        const documents = documentData === null || documentData === void 0 ? void 0 : documentData.documents.map((document) => {
            var _a;
            const signedItem = (_a = signedUrlsData === null || signedUrlsData === void 0 ? void 0 : signedUrlsData.signedUrls) === null || _a === void 0 ? void 0 : _a.find((signedUrl) => signedUrl.id === document.id);
            return Object.assign(Object.assign({}, document), { signedUrl: signedItem === null || signedItem === void 0 ? void 0 : signedItem.signedUrl });
        });
        const hasPendingDocuments = !!(documentData === null || documentData === void 0 ? void 0 : documentData.documents.find((document) => document.status === DOCUMENT_STATUSES.PENDING));
        if (documents === null || documents === void 0 ? void 0 : documents.length) {
            setOldDocument(documents[0]);
        }
        if (!hasPendingDocuments) {
            setShowLetters(useLetters);
            if (documents && ((_a = documents[0]) === null || _a === void 0 ? void 0 : _a.signedUrl)) {
                setSignedUrl((_b = documents[0]) === null || _b === void 0 ? void 0 : _b.signedUrl);
                setShowLetters(false);
            }
            setPendingOverlay(false);
        }
        else {
            setPendingOverlay(true);
            clearTimeout(refetchTimeoutRef.current);
            refetchTimeoutRef.current = setTimeout(() => {
                refetchTimeoutRef.current = 0;
                documentsRefetch({
                    query: {
                        foreignKeys: [userId || ''],
                        type: 'profile_picture',
                    },
                    options: {
                        order: {
                            field: 'createdAt',
                            direction: 'desc',
                        },
                    },
                });
                signedUrlsRefetch({
                    query: {
                        foreignKeys: [userId || ''],
                    },
                });
            }, 10000);
        }
    }, [documentData, documentError, signedUrlsData, signedUrlsError]);
    useImperativeHandle(ref, () => ({
        refetchAvatar() {
            documentsRefetch();
            signedUrlsRefetch();
        },
        getOldDocument() {
            return oldDocument;
        },
    }));
    return !showLetters ? (React.createElement("div", { className: "relative" },
        React.createElement("img", { className: `${className} ${overlapping ? '-mr-2' : ''}`, src: signedUrl, alt: altName, style: style }),
        pendingOverlay && (React.createElement("div", { className: "absolute top-0 left-0 flex justify-center items-center w-full h-full bg-green-transparent text-white text-xl" }, "Uploading...")))) : (React.createElement(LetterAvatar, { user: user, overlapping: overlapping }));
});
